import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  OnDestroy
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { Province } from '@ascschool/model/category/province.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { BaocaoService } from '@ascschool/services/baocao/baocao.service';
import { DistrictService } from '@ascschool/services/category/district.service';
import { LivingConditionService } from '@ascschool/services/category/living-condition.service';
import { NeedOfDisabilityService } from '@ascschool/services/category/need-of-disability.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { TypeOfEducationInvolveService } from '@ascschool/services/category/type-of-education-involve.service';
import { TypeOfPersonnelService } from '@ascschool/services/category/type-of-personnel.service';
import { TypeofEducationService } from '@ascschool/services/category/typeofeducation.service';
import { TypeOfSchoolService } from '@ascschool/services/category/typeofschool.service';
import { WardService } from '@ascschool/services/category/ward.service';
import { SchoolLevelService } from '@ascschool/services/school/school-level.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { Observable,Subject } from 'rxjs';
import { map,takeUntil } from 'rxjs/operators';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { DiplomasService } from '@ascschool/services/category/diplomas.service';
import { QualificationService } from '@ascschool/services/category/qualification.service';

@Component({
  selector: 'app-th-cbql-gv-cbdh-nkt',
  templateUrl: './th-cbql-gv-cbdh-nkt.component.html',
  styleUrls: ['./th-cbql-gv-cbdh-nkt.component.scss']
})
export class ThCbqlGvCbdhNktComponent implements OnInit,OnDestroy {
  constructor(
    private cdRef: ChangeDetectorRef,
    public _authService: AuthService,
    public sizePageService: SizePageService,
    private authQuery: AuthQuery,
    public utilService: UtilsService,
    private service: BaocaoService,
    private typeofEducationService: TypeofEducationService,
    private diplomaService: DiplomasService,
    private qualificationService: QualificationService, 
    private disProvincesService: ProvinceService,
    private districtService: DistrictService,
    private wardService: WardService,
    private disTypeOfSchoolsService: TypeOfSchoolService,
    private livingConditionService: LivingConditionService,
    private disTypeOfPersonnelService: TypeOfPersonnelService,
  ) { }
  get breadcrumbs(): string[] {
    return ['Báo cáo tổng hợp'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  @ViewChild('pageHeaderTable2', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable2 = content2;
    }
  }
  @ViewChild('pageHeaderTable3', { static: false }) set content3(content3: ElementRef) {
    if (content3) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable3 = content3;
    }
  }
  $unSubcsribe = new Subject();
  year = '';
  dataTable: any = [];
  dataHeaderRow1: any = [];
  dataHeaderRow2: any = [];
  dataHeaderRow3: any = [];
  keyFirstArr: any = [];
  keyIdArr: any = [];

  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  commonFilter = new CommonFilter();
  searchTerm: string = '';
  pageIndex: number = 1;
  province = new Province();
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize: number = this.pageSizeOptions[0];
  loading: boolean = true;
  Total: number = 0;
  thongtinCSGDList: any;
  ListCapHoc: any[] = [];
  ListLoaiHinh: any[] = [];
  ListDieuKien: any[] = [];
  firstRowOnPage: any;
  dataList: any;
  width: number;
  numberControl: number;
  private elementPageHeaderTable: ElementRef;
  private elementPageHeaderTable2: ElementRef;
  private elementPageHeaderTable3: ElementRef;
  getProvinceACFn: (value: any) => Observable<any>;
  ProvinceSubscription: any;
  ProvinceControl = new FormControl();
  @ViewChild('pageSample8', { static: false }) elementPageSample8: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  @ViewChild('Table', { static: false }) tableElement: NzTableComponent;
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation: number = 50;
  isCollapse = true;
  getTypeofEducationACFn: (value: any) => Observable<any>;
  TypeofEducationSubscription: any;
  TypeofEducationControl = new FormControl();
  getDiplomaACFn: (value: any) => Observable<any>;
  DiplomaSubscription: any;
  DiplomaControl = new FormControl();
  getQualificationACFn: (value: any) => Observable<any>;
  QualificationSubscription: any;
  QualificationControl = new FormControl(); 
  getDisProvincesACFn: (value: any) => Observable<any>;
  DisProvincesSubscription: any;
  DisProvincesControl = new FormControl();
  getDistrictACFn: (value: any) => Observable<any>;
  DistrictSubscription: any;
  DistrictControl = new FormControl();
  getDisWardACFn: (value: any) => Observable<any>;
  DisWardSubscription: any;
  DisWardControl = new FormControl();
  getDisTypeOfSchoolsACFn: (value: any) => Observable<any>;
  disTypeOfSchoolsSubscription: any;
  disTypeOfSchoolsControl = new FormControl();
  getLivingConditionsACFn: (value: any) => Observable<any>;
  LivingConditionSubscription: any;
  LivingConditionControl = new FormControl();
  getDisTypeOfPersonnelACFn: (value: any) => Observable<any>;
  disTypeOfPersonnelSubscription: any;
  disTypeOfPersonnelControl = new FormControl();
  sortNameFn = (a: Province, b: Province) => a.provinceName.localeCompare(b.provinceName);
  ngOnInit() {
    // this.commonFilter.PageIndex = 1;
    // this.commonFilter.PageSize = this.pageSizeOptions[0];
    this.reload();
    this.loadTypeofEducation(); 
    this.loadDisProvinces();
    this.loadDisTypeOfSchools();
    this.loadLivingCondition();
    this.loadDisTypeOfPersonnel();
    this.loadDiploma();
    this.loadQualification();
    this.maxHeight = window.innerHeight;
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
  }
  reload() {
    const _this = this;
    this.loading = true;
    _this.dataTable = [];
    this.resetData(); 
    this.changeYear();
    this.service.getRpCsgdThcb(this.commonFilter).pipe(takeUntil(this.$unSubcsribe)).subscribe(
      (response: any) => {
        if (response.data === null) {
          _this.dataTable = [];
        } else {
          this.resetData();
          this.handlingData(response);
          this.dataTable = response.data;
          this.width = 210 + (100 * this.keyFirstArr.length);
        }
        _this.loading = false;
      },
      (err: any) => {
        _this.dataTable = [];
        _this.loading = false;
      }
    );
  }

  handlingData(response: any) {
    const slloaiHinh = response.pivotLcsch.length;
    let row1 = [];
    let row2 = [];
    let row3 = [];
    let header2 = [];
    let header1 = [];
    response.pivotPh.forEach(ph => {
      row3.push(ph);
    });
    response.pivotCsch.forEach(ch => {
      ch.dataPtaId = "LCSCH_1007"
      row3.push(ch);

    });

    response.pivotLcsph.forEach(lcsph => {
      lcsph.dataPtaId = 1;
      row2.push(lcsph);
    });
    response.pivotLcsch.forEach(lcsch => {
      lcsch.dataPtaId = 1;
      row2.push(lcsch);
    });
    row2.push({ dataName: 'Trung tâm hỗ trợ GDHN', dataPtaId: 1 , dataId : "TongGDHN"}); 
    response.pivotTddt.forEach(tddt => {
      tddt.dataPtaId = 2;
      row2.push(tddt);
    });
    response.pivotDtbd.forEach(dtbd => {
      dtbd.dataPtaId = 3;
      row2.push(dtbd);
    });
    row1.push({ dataName: 'Đang làm việc tại cơ sở giáo dục', dataId: 1 });
    // // tslint:disable-next-line: max-line-length
    row1.push({ dataName: 'Trình độ đào tạo', dataId: 2 });
    row1.push({ dataName: 'Đào tạo, bồi dưỡng về giáo dục đặc biệt', dataId: 3 });
    row2.push({ dataName: 'Đã tham gia', dataPtaId: 3 , dataId : "DaThamGia"}); 
    row2.push({ dataName: 'Chưa tham gia', dataPtaId: 3 , dataId : "ChuaThamGia"}); 
    row2.forEach((h2) => {
      let colSpan = 0;
      let rowSpan = 0;
      row3.forEach(h3 => {
        if (h2.dataId === h3.dataPtaId) {
          colSpan += 1;
        }
      });
      if (colSpan > 0) {
        h2.colSpan = colSpan;
      } else {
        h2.rowSpan = 2;
      }
    });
    row1.forEach((r1) => {
      let colSpan = 0;
      let rowSpan = 0;
      row2.forEach(r2 => {
        if (r1.dataId === r2.dataPtaId) {
          if (typeof r2.colSpan == "number") {
            colSpan += r2.colSpan;
          }
          if (typeof r2.rowSpan == "number") {
            colSpan += 1;
          }
        }
      });
      if (colSpan > 0) {
        r1.colSpan = colSpan;
      }
    })
    // Tạo row 2 đi theo của mỗi cột 
    // Lấy ra key đầu tiên của header 1 row=2
    row2.forEach(r2 => {
      // tslint:disable-next-line: no-shadowed-variable
      let id = '';
      row3.forEach(r3 => {
        if (r2.dataId === r3.dataPtaId) {
          if(r2.dataId === "LCSCH_1007"){
            id= r2.dataId + r3.dataId
          }else{
            id = r3.dataId;
          } 
          this.keyFirstArr.push(id);
        }
      });
    }); 

    row1.forEach(r1 => {
      let id = 0;
      row2.forEach(r2 => {
        if (r1.dataId === r2.dataPtaId && r2.rowSpan == 2) {
        
          id = r2.dataId;
          this.keyFirstArr.push(id);
        }
      });
    });   
    this.dataHeaderRow1 = row1;
    this.dataHeaderRow2 = row2;
    this.dataHeaderRow3 = row3;
  }
  changeYear(){
    this.commonFilter.year = this.year;
  }

  resetData() {
    this.dataTable = [];
    this.dataHeaderRow1 = [];
    this.dataHeaderRow2 = [];
    this.dataHeaderRow3 = [];
    this.keyFirstArr = [];
    this.keyIdArr = [];
  }
  exportExcel() {
    // document.getElementById('btnvF').click();
    this.commonFilter.year = this.year;
    this.service.exportRpCsgdThcb(this.commonFilter).subscribe((data:any) => {
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'csgdthcb.xlsx';
      link.click();
    });
  }
  search() {
    this.commonFilter.PageIndex = 1;
    this.reload();
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.checkCaculateSize();
    }, 500);
    // keyboard
    this.shortcuts.push({
      key: ['alt + n'],
      label: 'Help',
      description: 'Cmd + b',
      command: (e) => console.log('alt + n'),
      preventDefault: true
    });
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateSize() {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = 210 + (100 * this.keyFirstArr.length);
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.elementPageHeaderTable2,
      this.elementPageHeaderTable3,
      this.heightPagnagation
    );
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.width = this.widthfnc();
    this.checkCaculateSize();
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateSize();
  }
  resetForm(): void { }
  loadTypeofEducation() {
    // tslint:disable-next-line: max-line-length
    this.getTypeofEducationACFn = (value: any) => this.typeofEducationService.getTypeofEducationSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.typeOfEducationName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.TypeofEducationSubscription) {
      this.TypeofEducationSubscription = this.TypeofEducationControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'TypeOfEducationId', this.TypeofEducationControl.value);
      });
    }
  }
  changeEducationACFn(control: FormControl) {
    this.TypeofEducationControl = control;
  }
  loadDiploma() {
    // tslint:disable-next-line: max-line-length
    this.getDiplomaACFn = (value: any) => this.diplomaService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.diplomaName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.DiplomaSubscription) {
      this.DiplomaSubscription = this.DiplomaControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'DiplomaId', this.DiplomaControl.value);
      });
    }
  }
  changeDiplomaACFn(control: FormControl) {
    this.DiplomaControl = control;
  }

  loadQualification() {
    // tslint:disable-next-line: max-line-length
    this.getQualificationACFn = (value: any) => this.qualificationService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.qualificationName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.QualificationSubscription) {
      this.QualificationSubscription = this.QualificationControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'QualificationId', this.QualificationControl.value);
      });
    }
  }
  changeQualification(control: FormControl) {
    this.QualificationControl = control;
  }
 
 
  loadDisProvinces() {
    // tslint:disable-next-line: max-line-length
    this.getDisProvincesACFn = (value: any) => this.disProvincesService.getProvinceSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.DisProvincesSubscription) {
      this.DisProvincesSubscription = this.DisProvincesControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.DisProvincesControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisProvincesACFn(control: FormControl) {
    this.DisProvincesControl = control;
    if (this.DisProvincesControl) {
      this.loadDistrict();
      this.DistrictControl.setValue(null);
    }
  }
  loadDistrict() {
    // tslint:disable-next-line: max-line-length
    this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({ searchTerm: value, ProvinceId: this.valueIfHas(this.DisProvincesControl), PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.DistrictSubscription) {
      this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDistrictACFn(control: FormControl) {
    this.DistrictControl = control;
    if (this.DistrictControl) {
      this.loadDisWard();
      this.DisWardControl.setValue(null);
    }
  }
  loadDisWard() {
    // tslint:disable-next-line: max-line-length
    this.getDisWardACFn = (value: any) => this.wardService.getWardSelectPaging({ searchTerm: value, DistrictId: this.valueIfHas(this.DistrictControl), PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.wardName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.DisWardSubscription) {
      this.DisWardSubscription = this.DisWardControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'WardId', this.DisWardControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changeDisWardACFn(control: FormControl) {
    this.DisWardControl = control;
  }
  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value !== 'string') { return control.value.id; }
    return '';
  }
  loadDisTypeOfSchools() {
    // tslint:disable-next-line: max-line-length
    this.getDisTypeOfSchoolsACFn = (value: any) => this.disTypeOfSchoolsService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.typeOfSchoolName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.disTypeOfSchoolsSubscription) {
      this.disTypeOfSchoolsSubscription = this.disTypeOfSchoolsControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'disTypeOfSchoolsId', this.disTypeOfSchoolsControl.value);
      });
    }
  }
  changeDisTypeOfSchools(control: FormControl) {
    this.disTypeOfSchoolsControl = control;
  }

  loadLivingCondition() {
    // tslint:disable-next-line: max-line-length
    this.getLivingConditionsACFn = (value: any) => this.livingConditionService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.LivingConditionSubscription) {
      this.LivingConditionSubscription = this.LivingConditionControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'livingConditionId', this.LivingConditionControl.value);
      });
    }
  }
  changeLivingCondition(control: FormControl) {
    this.LivingConditionControl = control;
  }
  loadDisTypeOfPersonnel() {
    // tslint:disable-next-line: max-line-length
    this.getDisTypeOfPersonnelACFn = (value: any) => this.disTypeOfPersonnelService.getTypeOfPersonnelSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.typeOfPersonnelName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    // tslint:disable-next-line: max-line-length
    if (!this.disTypeOfPersonnelSubscription) {
      this.disTypeOfPersonnelSubscription = this.disTypeOfPersonnelControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'TypeOfPersonnelId', this.disTypeOfPersonnelControl.value);
      });
    }
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  changedisTypeOfPersonnel(control: FormControl) {
    this.disTypeOfPersonnelControl = control;
  }
  clear() {
    this.year = '';
    this.TypeofEducationControl.setValue(null);
    this.QualificationControl.setValue(null);
    this.DisProvincesControl.setValue(null);
    this.DistrictControl.setValue(null);
    this.DisWardControl.setValue(null);
    this.disTypeOfSchoolsControl.setValue(null);
    this.LivingConditionControl.setValue(null);
    this.DiplomaControl.setValue(null);
    this.disTypeOfPersonnelControl.setValue(null);
    this.reload();
  }
  ngOnDestroy(): void {
    this.$unSubcsribe.next();
    this.$unSubcsribe.complete();
}
}
